'use client';

import useLoginModal from "../hooks/useLoginModal";
import { useRouter } from "next/navigation";
import apiService from "../services/apiService";
import React from "react";

interface ContactButtonProps {
    userId: string | null;
    vendorId: string;
    disabled?: boolean;
}

const ContactButton: React.FC<ContactButtonProps> = ({
    userId, 
    vendorId,
    disabled = false
}) => {
    const login = useLoginModal();
    const router = useRouter();

    const startConversation = async () => {
        if (disabled) return;

        if (userId) {
            const conversation = await apiService.get(`/api/chat/start/${vendorId}/`)

            if (conversation.conversation_id) {
                router.push(`/inbox/${conversation.conversation_id}`)
            }
        } else {
            login.open();
        }
    }

    return (
        <button 
            onClick={startConversation}
            disabled={disabled}
            className={`
                inline-block py-4 px-6 bg-green-600 hover:bg-green-700 text-white rounded-xl cursor-pointer transition
                ${disabled 
                ? 'bg-green-300 cursor-not-allowed opacity-60' 
                : 'bg-green-600 hover:bg-green-700 cursor-pointer'}
                text-white
            `}
        >
            Contato
        </button>
    )
}

export default ContactButton;